import Banner from "./Banner/Banner.jsx";
import ExploreSection from "./ExploreSection/ExploreSection.jsx";
import BrowseCategory from "./BrowseCategories/BrowseCategory.jsx";
import ValueProp from "./ValueProp/ValueProp.jsx";
import Testimonials from "./Testimonials/Testimonials.jsx";
import WhoNeedsSoftware from "./WhoNeedsSoftware/WhoNeedsSoftware.jsx";
import ExploreMobileApp from "./ExploreMobileApp/ExploreMobileApp.jsx";
import Patners from "./Patners/Patners.jsx";

function HomePage() {
  return (
    <>
      <Banner />
      <ExploreSection />
      <BrowseCategory />
      <ValueProp />
      <WhoNeedsSoftware />
      <ExploreMobileApp />
      <Testimonials />
      <Patners />
    </>
  );
}

export default HomePage;
